export const PROMOTION_MODEL_COVER_IMAGE_WIDTH = 160;
export const PROMOTION_MODEL_COVER_IMAGE_HEIGHT = 133;

export const PROMOTION_DESKTOP_BANNER_IMAGE_WIDTH = 569;
export const PROMOTION_DESKTOP_BANNER_IMAGE_HEIGHT = 354;

export const PROMOTION_MORE_PROMOS_ICON_SIZE = 9;

export const PROMOTION_POSTED_ON_DATE_FORMAT = 'DD-MMM-YYYY';

export const DEALER_TYPE_AD = 'ad';
export const DEALER_TYPE_PI = 'pi';

export const CACHE_KEY_NEWCAR_PROMOTION_DATA = (
  'new_car_promo_data'
);

export const CACHE_TTL_NEWCAR_PROMOTION_DATA = 1200;

export const MODAL_STEP_CHECK_SHORTLIST = 'checkShortlist';
export const MODAL_STEP_PROMOTION_DETAILS = 'promotionDetails';
export const MODAL_STEP_CHECK_SHORTLIST_RESULT = 'checkShortlistResult';

export const BACKDROP_TRANSITION_DURATION_MS_DEFAULT = 300;
